import { css, styled } from 'next-yak';

import { SkeletonBase } from './skeleton-base.styles';

type SkeletonCircleTProps = {
  $size?: string;
};

export const SkeletonCircle = styled(SkeletonBase)<SkeletonCircleTProps>`
  border-radius: 50%;

  ${({ $size }) =>
    $size &&
    css`
      height: ${() => $size};
      width: ${() => $size};
    `};
`;
